@use "styles" as *;

:host {
  display: block;
}
